import { render, staticRenderFns } from "./modal-ckyc.vue?vue&type=template&id=7cefc6f1&scoped=true&"
import script from "./modal-ckyc.vue?vue&type=script&lang=js&"
export * from "./modal-ckyc.vue?vue&type=script&lang=js&"
import style0 from "./modal-ckyc.vue?vue&type=style&index=0&id=7cefc6f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cefc6f1",
  null
  
)

export default component.exports